import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClipboardModule } from "@angular/cdk/clipboard";
import Components, { UiPopoverComponent } from "./components";
import Directives, { UiPopoverDirective } from "./directives";

@NgModule({
  imports: [CommonModule, ClipboardModule],
  declarations: [Components, Directives],
  exports: [UiPopoverComponent, UiPopoverDirective]
})
export class UiPopoverModule {}
